/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkflowOwnershipValidationCodeRequest
 */
export interface WorkflowOwnershipValidationCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkflowOwnershipValidationCodeRequest
     */
    email: string;
}

/**
 * Check if a given object implements the WorkflowOwnershipValidationCodeRequest interface.
 */
export function instanceOfWorkflowOwnershipValidationCodeRequest(value: object): value is WorkflowOwnershipValidationCodeRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function WorkflowOwnershipValidationCodeRequestFromJSON(json: any): WorkflowOwnershipValidationCodeRequest {
    return WorkflowOwnershipValidationCodeRequestFromJSONTyped(json, false);
}

export function WorkflowOwnershipValidationCodeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowOwnershipValidationCodeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function WorkflowOwnershipValidationCodeRequestToJSON(value?: WorkflowOwnershipValidationCodeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
    };
}

